import {Trip} from "./Trip";
import React, {useState} from "react";
import {Chip} from "@mui/material";
import TripModal from "./TripModal";

interface TripListItemProps {
    trip: Trip;
    color?: string;
}

const TripListItem: React.FC<TripListItemProps> = ({trip, color = "primary.main"}) => {
    const [selectedTrip, setSelectedTrip] = useState<Trip | null>(null);
    const [open, setOpen] = useState(false);

    const handleOpen = (trip: Trip) => {
        setSelectedTrip(trip);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedTrip(null);
    };

    return (
        <>
            <Chip
                label={trip.name}
                variant="outlined"
                onClick={() => handleOpen(trip)}
                sx={{
                    borderColor: color,
                    height: '30px',
                    fontSize: '0.9rem',
                    '& .MuiChip-label': {
                        padding: '0 20px'
                    }
                }}
            />
            {open && <TripModal open={open} onClose={handleClose} trip={selectedTrip}/>}
        </>
    )
}

export default TripListItem;